
export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILS = 'FETCH_USERS_FAILS';

export const SUBMIT_USERS = 'SUBMIT_USERS'
export const SUBMIT_USERS_SUCCESS = 'SUBMIT_USERS_SUCCESS'
export const SUBMIT_USERS_FAILS = 'SUBMIT_USERS_SUCCESS'

export const FETCH_USER_BY_ID = 'FETCH_USER_BY_ID';
export const FETCH_USER_BY_ID_SUCCESS = 'FETCH_USER_BY_ID_SUCCESS';
export const FETCH_USER_BY_ID_FAILS = 'FETCH_USER_BY_ID_FAILS';
